import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

export default function Movements() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/inventory/movements", { params: { limit: 400 } }).then(r => setRows(r.data)); }, []);

  return (
    <div className="p-6 md:p-10">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground mb-2">Movements</div>
        <h1 className="font-display text-4xl tracking-tight" data-testid="movements-title">Inventory Movement History</h1>
      </div>
      <Card className="border-border shadow-sm overflow-hidden">
        <div className="overflow-x-auto thin-scroll">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>When</TableHead>
                <TableHead>SKU</TableHead>
                <TableHead>Product</TableHead>
                <TableHead className="text-right">Δ</TableHead>
                <TableHead>Reason</TableHead>
                <TableHead>By</TableHead>
                <TableHead className="text-right">Resulting Qty</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map(r => (
                <TableRow key={r.id} className="hover:bg-slate-50" data-testid={`mov-${r.id}`}>
                  <TableCell className="text-xs text-muted-foreground">{new Date(r.at).toLocaleString("en-ZA")}</TableCell>
                  <TableCell className="font-mono text-xs">{r.sku}</TableCell>
                  <TableCell className="text-sm">{r.product_name}</TableCell>
                  <TableCell className={`text-right font-mono text-xs ${r.delta > 0 ? "text-emerald-700" : "text-[#C05746]"}`}>
                    {r.delta > 0 ? "+" : ""}{r.delta}
                  </TableCell>
                  <TableCell className="text-xs">{r.reason}</TableCell>
                  <TableCell className="text-xs">{r.actor_name}</TableCell>
                  <TableCell className="text-right font-mono text-xs">{r.resulting_qty}</TableCell>
                </TableRow>
              ))}
              {rows.length === 0 && (
                <TableRow><TableCell colSpan={7} className="text-center py-10 text-muted-foreground">No movements yet.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
